import { render, staticRenderFns } from "./tree.vue?vue&type=template&id=7048b58c&"
import script from "./tree.vue?vue&type=script&lang=js&"
export * from "./tree.vue?vue&type=script&lang=js&"
import style0 from "./tree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports